import React from 'react';
export var CardTitle = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: "mb-2 border-bottom card-body-title " + className },
        React.createElement("h3", { className: "pb-0 mb-2" }, children)));
};
CardTitle.defaultProps = {
    className: '',
};
export default CardTitle;
//# sourceMappingURL=CardTitle.js.map